export const USER_UPDATED = "USER_UPDATED";
export const PASSCODE_ICON_UPDATED = "PASSCODE_ICON_UPDATED";
